import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { computed, onMounted, ref, useTemplateRef } from "vue";


const MAX_PERCENTAGE = 100;
const MIN_PERCENTAGE = 68;
const MAX_DELAY_MS = 1300;
function generateRandomLine(count: number) {
    const percentages = [];
    for (let i = 0; i < count; i++) {
        const randomWidth =
            Math.floor(Math.random() * (MAX_PERCENTAGE - MIN_PERCENTAGE + 1)) + MIN_PERCENTAGE;
        const randomDelay = Math.floor(Math.random() * MAX_DELAY_MS);
        percentages.push({
            key: Math.random(),
            width: `${randomWidth}%`,
            animationDelay: `${randomDelay}ms`,
        });
    }
    return percentages;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AiGenerationSkeleton',
  props: {
    mode: { default: "blur" }
  },
  setup(__props: any) {



const noOfLines = ref(4);
const LINE_HEIGHT = 40;
const preloaderBox = useTemplateRef("preloaderBox");
const LINES = computed(() => generateRandomLine(noOfLines.value));
onMounted(() => {
    if (preloaderBox.value) {
        noOfLines.value = Math.round(preloaderBox.value.offsetHeight / LINE_HEIGHT);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "preloaderBox",
    ref: preloaderBox,
    class: _normalizeClass(["z-10 p-3 h-full flex justify-center items-center flex-col gap-2 overflow-hidden", { 'backdrop-blur-[4px]': _ctx.mode === 'blur' }])
  }, [
    (_ctx.mode === 'skeleton')
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(LINES.value, ({ key, width, animationDelay }) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: "generation-bar w-full rounded-full",
            style: _normalizeStyle({
                    width,
                    animationDelay,
                    backgroundColor: '#E8EAED',
                })
          }, "   ", 4))
        }), 128))
      : _createCommentVNode("", true)
  ], 2))
}
}

})